<template>
  <div class="pulse-diagnosis-result">
    <div class="pulse-card-container">
      <div class="pulse-risk-board">
        <div
          class="pulse-risk-col"
          v-for="item in riskLevels"
          :key="item.name"
        >
          <div class="pulse-current-indicator-wrapper">
            <div
              class="pulse-current-indicator"
              v-if="normalizedRiskLevel === item.name"
            >
              <span class="pulse-current-text">当前</span>
              <div class="pulse-triangle-down"></div>
            </div>
          </div>
          <div class="pulse-risk-bar" :style="{ background: item.color }"></div>
          <div class="pulse-risk-label">{{ item.name }}</div>
        </div>
      </div>

      <div class="pulse-text-block" v-if="diagnosisResult.result">
        <span class="pulse-label-strong">辨证结果：</span>{{ diagnosisResult.result }}
      </div>
      <div class="pulse-text-block" v-if="diagnosisResult.healthAnalysis">
        <span class="pulse-label-strong">辨证解析：</span>{{ diagnosisResult.healthAnalysis }}
      </div>
      <div class="pulse-text-block" v-if="diagnosisResult.assessment">
        <span class="pulse-label-strong">体征综合评估：</span>{{ diagnosisResult.assessment }}
      </div>

      <div class="bottom-statement">
        重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论。如已有身体不适，请及时咨询医生。
        <div class="time-text" v-if="reportData.createAt">生成时间：{{ reportData.createAt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PulseDiagnosisResult',
  props: {
    reportData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      riskLevels: [
        { name: '较低风险', color: 'linear-gradient(90deg, #75c7de 0%, #66b9ee 100%)' },
        { name: '中风险', color: 'linear-gradient(90deg, #9ed2a2 0%, #8aca9b 100%)' },
        { name: '中高风险', color: 'linear-gradient(90deg, #ff975c 0%, #ff8a53 100%)' },
        { name: '较高', color: 'linear-gradient(90deg, #ff6d18 0%, #ff5600 100%)' }
      ]
    };
  },
  computed: {     
    diagnosisResult() { 
      return this.reportData?.pulseReport?.diagnosisResult || {};
    },
    normalizedRiskLevel() {
      const riskLevel = this.diagnosisResult?.riskLevel || '';
      const matched = this.riskLevels.find(item => riskLevel.includes(item.name) || item.name.includes(riskLevel));
      return matched ? matched.name : '';
    }
  }                                       
};
</script>

<style lang="scss" scoped>
.pulse-card-container {
  min-height: calc(100vh - 130px);
  background: #fff;
  padding: 24px 16px 32px;
}

.pulse-risk-board {
  display: flex;
  margin-top: 110px;
  margin-bottom: 48px;
}

.pulse-risk-col {
  flex: 1;
  text-align: center;
}

.pulse-current-indicator-wrapper {
  height: 58px;
  position: relative;
}

.pulse-current-indicator {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pulse-current-text {
  min-width: 68px;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid #ff8a53;
  color: #ff7e3c;
  font-size: 14px;
  font-weight: 600;
  background: #fff;
}

.pulse-triangle-down {
  width: 0;
  height: 0;
  margin-top: -1px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #ff8a53;
}

.pulse-risk-bar {
  height: 14px;
  border-radius: 999px;
  margin: 0 3px 14px;
}

.pulse-risk-label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.pulse-text-block {
  font-size: 16px;
  line-height: 1.85;
  color: #333;
  margin-top: 28px;
}

.pulse-label-strong {
  font-weight: 700;
}

.bottom-statement {
  margin-top: 40px;
  font-size: 13px;
  line-height: 1.7;
  color: #a0a4aa;
}

.time-text {
  margin-top: 8px;
}
</style>
